import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = 'Confirm', onConfirm, destructive = true, disabled = false }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" className="h-9 rounded-lg" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          variant={destructive ? 'destructive' : 'default'}
          className="h-9 rounded-lg font-semibold"
          disabled={disabled}
          onClick={async () => {
            onOpenChange(false);
            await onConfirm();
          }}
        >
          {confirmLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ConfirmDialog;
